import Config from '../../utils/Config';

export const t = (key, lang_code?): string => {

  const resources = {
    de: {
      translation: {
        clarinet: 'Klarinette',
        altosax: 'Alt-Saxophone',
        beginner: 'Anfänger',
        intermediate: 'Fortgeschritten',
        professional: 'Profi'

      },
    },
    en: {
      translation: {},
    },
    es: {
      translation: {},
    },
  };
  const lang = lang_code ? lang_code : (Config.getDrupalVar('path.currentLanguage') as string);
  const translation = resources[lang].translation[key];
  return translation ?? key;
};
